import React, { useEffect, useState } from "react";
import { Modal, Input } from "antd";
import Button from "../components/shared/button";

const RatingModal = ({
  isfeedbackOpen,
  setisfeedbackOpen,

  record,
}) => {
  const [activeEmoji, setActiveEmoji] = useState(null);
  const emojis = [
    {
      id: 1,
      label: "Poor!",
      color: "#F16A77",
      dullSrc: "../../assets/icons/angry-dull.svg",
      activeSrc: "../../assets/icons/angry-colored.svg",
    },
    {
      id: 2,
      label: "Good!",
      color: "#FCC378",
      dullSrc: "../../assets/icons/wink-dull.svg",
      activeSrc: "../../assets/icons/wink-colored.svg",
    },
    {
      id: 3,
      label: "V-nice!",
      color: "#FCC378",
      dullSrc: "../../assets/icons/smiling-dull.svg",
      activeSrc: "../../assets/icons/smiling-colored.svg",
    },
    {
      id: 4,
      label: "Awesome!",
      color: "#FCC378",
      dullSrc: "../../assets/icons/laughing-dull.svg",
      activeSrc: "../../assets/icons/laughing-colored.svg",
    },
  ];
  const handleOk = () => {
    setisfeedbackOpen(false);
  };

  const handleCancel = () => {
    setisfeedbackOpen(false);
  };

  // useEffect(() => {
  //   feedbackData && feedbackData.length > 0 &&   feedbackData.map((item, index) => {
  //     if (index === recordId-1) {
  //       console.log(item);
  //     }
  //   });
  // }, []);

  console.log(record)

  return (
    <>
      <Modal
        open={isfeedbackOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="del-modal"
        centered={true}
        width="35%"
      >
        <div className="modal-content  flex flex-col w-100  py-[19px] px-[36px] max-sm:px-[20px]">
          <h5 className="text-blue font-manrope font-medium ">Feedback</h5>
          <div className="name-div flex justify-between items-center mt-[31px] pb-[12px] border-solid border-b-2 border-b-[#D2D2D2]">
            <div className="left flex items-center gap-[6px]">
              <div className="w-[40px] h-[40px] sm-s:h-[40px] sm-s:w-[40px] cursor-pointer rounded-[31px] flex items-center justify-center py-[3px] px-[16px] bg-[var(--Primary-color,#143A62)] shadow-[0px_39.919px_73.47px_rgba(191,191,191,0.32)] backdrop-blur-[72.719px]">
                <h6 className="uppercase text-white font-semibold sm-s:text-[18px]">
                  t
                </h6>
              </div>
              <p className="text-center text-[#000] font-inter small">
                {record?.user}                </p>
            </div>
            <p className=" text-[#ADADAD] font-inter small font-medium">
              {record?.date}
            </p>
          </div>
          {/* <div className="mt-[17px]">
            <p className=" text-[#000] font-inter large">Ratings:</p>
            <div className="flex items-center gap-[30px] mt-[16px]">
              {emojis.map((emoji) => (
                <div
                  key={emoji.id}
                  className="flex flex-col items-center gap-[9px]"
                >
                  <img
                    src={
                      activeEmoji === emoji.id ? emoji.activeSrc : emoji.dullSrc
                    }
                    alt={emoji.label}
                    className={`cursor-pointer w-[36px] h-[36px] transition-transform duration-300 ${
                      activeEmoji === emoji.id ? "scale-110" : "scale-100"
                    }`}
                  />
                  <p
                    className={`font-inter small font-bold transition-opacity duration-300 ${
                      activeEmoji === emoji.id ? "opacity-100" : "opacity-0"
                    }`}
                    style={{ color: emoji.color }}
                  >
                    {emoji.label}
                  </p>
                </div>
              ))}
            </div>
          </div> */}
          <div className="mt-[17px]">
            <p className=" text-[#000] font-inter large">Comment:</p>
            <p className="mt-[11px] text-[#B6B6B6]">
              {record?.comment}
            </p>
          </div>
          {/* <div className="mt-[40px] flex gap-[10px]">
            <Button
              text="Delete"
              className="button btn-warning m-auto"
              height={45}
              width={176}
              onClick={handleCancel}
              imgright="fluent:delete-16-regular"
            />
          </div> */}
        </div>
      </Modal>
    </>
  );
};

export default RatingModal;
